<template
  ><!--刮刮乐 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <!-- <div class="headReturn">
      <span @click="clickLocalStep"> <i class="el-icon-arrow-left"></i> 返回列表</span>
      <span style="margin: 0 20px">|</span>
      <span class="name">刮刮乐</span>
    </div> -->
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">刮刮乐</span>
    </div>
    <!--  活动条件表单部分 -->
    <div v-loading="fromLoading" class="secondstep">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="backgroundForm"
        label-width="120px"
        :rules="rules"
      >
        <div class="newsInfo" style="margin-top: 0px;">基本信息</div>
        <el-form-item label="活动名称:" required>
          <!-- prop="activityName" 活动名称 -->
          <el-input
            v-model="ruleForm.activityName"
            maxlength="50"
            show-word-limit
            placeholder="请填入活动名称"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间:" required>
          <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
          <div class="my_select_time">
            <el-date-picker
              v-model="activityTimeValue"
              type="datetimerange"
              class="rangeTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              ref="timeBox"
              @change="activityTimeChange"
              style="width: 400px; font-size: 12px"
              :picker-options="pickerOptionsValue"
              :default-time="defaultTime"
            >
            </el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="activityTimeValue = []"
            ></i>
            <img
              src="@/assets/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
          <span class="lastTime" style="color: #666">
            活动持续 <span style="color: #2670FB">{{ timeDay }}</span> 天
            <span style="color: #2670FB">{{ timeOut }}</span> 小时
            <el-tooltip
              class="item"
              effect="light"
              content="活动有效期不可超过订购有效期"
              placement="bottom"
            >
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </span>
        </el-form-item>
        <el-form-item label="活动对象:" required>
          <el-radio-group v-model="ruleForm.activityObject" @change="handleActivityObj" :disabled="isStartEdit">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">指定身份</el-radio>
            <el-radio :label="2" disabled>指定人群</el-radio>
          </el-radio-group>
          <span class="margin-left-12">
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~">
              <el-button slot="reference" disabled>{{ selectCrowdText }}</el-button>
            </el-popover>
          </span>
        </el-form-item>
        <el-form-item
          label="新老客户:"
          required
          v-if="ruleForm.activityObject === 1"
        >
          <el-radio-group v-model="ruleForm.newOldCustomer" :disabled="isStartEdit">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">新客</el-radio>
            <el-radio :label="2">老客</el-radio>
          </el-radio-group>
          <span class="margin-left-12">
            <span class="tips-style margin-left-12">新老客说明</span>
            <el-tooltip class="item" effect="light" placement="bottom">
              <span slot="content">
                <div>历史订单中已完成订单的订单数为0则定义为新客</div>
                <div>历史订单中已完成订单的订单数≥1则定义为老客</div>
              </span>
              <i class="el-icon-question margin-left-8"></i>
            </el-tooltip>
          </span>
        </el-form-item>
        <!-- Note--京获客迭代V2.2参与对象 -->
        <el-form-item label="参与对象:" required prop="partner" v-if="ruleForm.activityObject == '1'">
          <el-checkbox-group
            v-model="ruleForm.partner"
            @change="checkListchange"
            :disabled="isStartEdit"
          >
            <el-checkbox label="-1" name="partner">全部</el-checkbox>
            <el-checkbox
              label="0"
              name="partner"
              :disabled="ruleForm.partner == -1"
              >非会员</el-checkbox
            >

            <el-checkbox
              v-for="(item, index) in levelList"
              :key="index"
              :label="index + 1 + ''"
              name="partner"
              :disabled="ruleForm.partner == -1"
              >{{ item }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="isEditOrDraft"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>
        <div class="newsInfo">活动信息</div>
        <!-- Note--京获客V2.2 去除更多活动页面 -->
        <!-- <el-form-item label="更多活动页面:" required>
          <el-input v-model="ruleForm.extraUrl" show-word-limit placeholder="请填入" style="width: 400px"></el-input>
          <div style="color:#999999">注意：自定义跳转链接必须为京东域内链接</div>
        </el-form-item> -->
        <el-form-item label="活动图片:" required>
          <div>
            <el-button
              :disabled="isStartEdit"
              slot="reference"
              @click="giftPopup = true"
              type="text"
              style="width:95px;background: #2670FB;color:#fff;"
              >选择模板</el-button
            >
          </div>
          <div class="smart">
            <div class="smart_left">
              <div class="smart_content">
                <img v-if="ruleForm.noWinImageUrl" :src="ruleForm.noWinImageUrl" alt="" />
              </div>
            </div>
            <div class="smart_right">
              <div class="smart_content">
                <img v-if="ruleForm.winImageUrl" :src="ruleForm.winImageUrl" alt="" />
              </div>
            </div>
          </div>
          <div class="smart_right_tip">
            图为预览效果，以实际投放位置效果为准
          </div>
        </el-form-item>
        <div class="newsInfo">奖品设置</div>
        <el-form-item label="抽奖和中奖限制:">
          活动期间每人每天抽奖不超过&nbsp;<el-input
          :disabled="isStartEdit"
            @input="ruleForm.oneDayMaxDrawNumber = getNumberData($event, 0)"
            style="width:60px"
            @change="orderChange"
            v-model="ruleForm.oneDayMaxDrawNumber"
            placeholder="请输入"
          ></el-input
          >&nbsp; 次，累计抽奖不超过&nbsp;
          <el-input
          :disabled="isStartEdit"
          @input="ruleForm.totalMaxDrawNumber = getNumberData($event, 0)"
            @change="orderChange"
            style="width:60px"
            v-model="ruleForm.totalMaxDrawNumber"
            placeholder="请输入"
          ></el-input
          >&nbsp; 次
          <div style="margin-top:5px">
            活动期间每人每天中奖不超过&nbsp;<el-input
            :disabled="isStartEdit"
              @input="ruleForm.oneDayMaxRewardNumber = getNumberData($event, 0)"
              @change="orderChange"
              style="width:60px"
              v-model="ruleForm.oneDayMaxRewardNumber"
              placeholder="请输入"
            ></el-input
            >&nbsp; 次，累计中奖不超过&nbsp;
            <el-input
              :disabled="isStartEdit"
              @input="ruleForm.totalMaxRewardNumber = getNumberData($event, 0)"
              @change="orderChange"
              style="width:60px"
              v-model="ruleForm.totalMaxRewardNumber"
              placeholder="请输入"
            ></el-input
            >&nbsp; 次
          </div>
          <div class="card-point">
            <div> <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:3px"></i>
                  注：此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制</div>
            <!-- <div class="card-connet">
              <p>
                此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制
              </p>
            </div> -->
          </div>
        </el-form-item>
        <el-form-item label="奖项设置:" required>
          <div>
            积累中奖率：<span style="color:#2670FB">{{ winningRate }}%</span>
          </div>
          <el-table
            :data="awardSettingsLsit"
            style="width: 100%; border: 1px solid #f0f0f0;margin-top: 15px;"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column label="奖项级别" width="100">
              <template slot-scope="scope">
                <span>{{ (scope.$index + 1) | toChinesNum }}等奖</span>
              </template>
            </el-table-column>
            <el-table-column label="选择奖品">
              <template slot-scope="scope">
                <span
                  style="color:#2670FB"
                  class="pointer"
                  @click="selectPacket(scope.$index, scope.row)"
                  >选奖品</span
                >
              </template>
            </el-table-column>

            <el-table-column label="奖品类型">
              <template slot-scope="scope">
                <span>{{ scope.row.prizeType | prizeType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="值"
              width="80"
              prop="price"
            ></el-table-column>
            <el-table-column label="奖品名称（12字内）" width="299">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.title"
                  maxlength="12"
                  :disabled="scope.row.prizeType != 3 || isStartEdit"
                  show-word-limit
                  style="width: 240px"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="奖品总数" width="200">
              <template slot-scope="scope">
                <el-input
                  @blur="beAdd(scope.row)"
                  v-model="scope.row.totalAmount"
                  @input="scope.row.totalAmount = getNumberData($event, 0)"
                  maxlength="10"
                  class="inputcount"
                  show-word-limit
                  style="width: 150px"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column width="160">
              <template slot="header">
                <span>中奖率</span>
                <el-popover
                  placement="top-start"
                  offset="100"
                  width="480"
                  trigger="hover"
                  content="中奖总概率可设置区间为0%至100%。本软件中奖概率是按数学中的概率统计学来计算的，并非硬性指标。 比如概率为1%，并非100次抽奖有且只有1次中奖，也不是第100次抽奖才会中奖。 而是每一次抽奖的机率都是平等的，第一次抽是1%,第100次、1万次抽也是1%。 举个现实中抽奖的例子，抽奖箱中有100个球，其中1个是红球代表中奖，其它99个是白球代表不中奖，每一次只能从中抽取1个球， 抽完后再放入箱中，下一个人再来抽(即每次抽奖箱中都有100个球，保证每次抽奖的概率平等性)，这样有可能第1个抽奖的就抽中了红球，或有可能第100个抽奖的都没抽中，也或100个人抽了已经有3个抽中了红球都有可能，都是属于统计学的概率问题。"
                >
                  <span slot="reference">
                    <p class="question_icon">?</p>
                  </span>
                </el-popover>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.percentage"
                  @input="(e) => (scope.row.percentage = oninput2(e))"
                  placeholder="请输入"
                  style="width: 80px;margin-right:5px;"
                  :disabled="isStartEdit"
                ></el-input
                >%
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span
                  style="color:#fe4d45"
                  v-show="scope.$index != 0"
                  class="pointer"
                  @click="deletePacket(scope.$index)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
          <div @click="addPacket" class="add_btn1">
            <!-- <img style="width:24px" src="../../../assets/images/add.svg" alt="" /> -->
            增加奖项
          </div>
          <!-- <div
            v-if="staute == 2"
            class="backgroundOpacity"
            style="height: 100%;"
          ></div> -->
          <div class="card-point">
            <div> <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:3px"></i>
                  说明：</div>
            <div class="card-connet" style="padding-left: 18px;">
              <p>
                1、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
              </p>
              <p>2、中奖率精确到小数点后三位，中奖概率不可设置0%</p>
            </div>
          </div>
        </el-form-item>
        
        <!-- <div v-if="backgroundOpacity && !isStartEdit" class="backgroundOpacity"></div> -->
      </el-form>
    </div>
    <div class="create_bottom">
      <el-button size="medium" @click="clickLocalStep()">
        {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          class="keepBtn"
          type="primary"
          size="medium"
          @click="joinBlackList = true"
          v-preventReClick
          >保存并完成设置</el-button
        >
      </template>
    </div>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProductAward"
      :Sans="venderType"
      :echoDate="echoDate"
      :actId="{ id: valueRow }"
      :num="1"
      :JingdouCount="JingdouCount"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 确定礼包模板弹窗 -->
    <gift-popup
      :activityDataID="29"
      @handleChoice="handleChoice"
      v-if="giftPopup"
    />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "../select_product";
import { mapState } from "vuex";
import {
  saveScratchers,
  editScratchers,
} from "@/api/paradiseAndTaskCommonController.js";
import giftPopup from "./giftPopup.vue";
export default {
  components: {
    selectProduct,
    giftPopup,
  },
  computed: {
    ...mapState(["venderType"]),
    winningRate() {
      let winningRate = 0;
      this.awardSettingsLsit.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });
      return winningRate;
    },
    selectCrowdText() {
      return this.crowdList.length === 0
        ? "选择人群"
        : `已选${this.crowdList.length}个`;
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "专属下单";
      }
      return result;
    },
    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ]; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp
          .toString()
          .split("")
          .reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        if (num >= 10 && num < 20) {
          newNum = newNum.substring(1, 3);
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
  },

  data() {
    return {
      crowdList: [],
      isStartEditTime:'',
      isStartEdit:false,
      levelList: [], //活动参与对象
      isCopy: false,
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      giftPopup: false,
      stepNum: 0,
      backgroundOpacity: false,
      isSave: true,
      valueRow: null,
      //
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      selectGoodsStateFilter: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      qrcode: null,
      joinBlackList: false,
      checked: false,
      activityStartTime: null,
      activityEndTime: null,
      timeDay: 0,
      timeOut: 0,
      rules: {
        //规则判断
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
      },
      ruleForm: {
        membershipTime:"",
        // 活动对象
        activityObject: 0,
        // 新老客户
        newOldCustomer: 0,
        //设置规则表单
        activityName: "",
        activityRulesText: "",
        oneDayMaxDrawNumber: "",
        totalMaxDrawNumber: "",
        oneDayMaxRewardNumber: "",
        totalMaxRewardNumber: "",
        extraUrl: "",
        noWinImageUrl: "",
        winImageUrl: "",
        thankImageUrl: "",
        gameTemplateId: "",
        partner: ["-1"], //参与对象
      },
      awardSettingsLsit: [
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
        },
      ],
      awardIndex: 0,
      timeState1: "",
      staute: 0,
    };
  },
  created() {
    // 数据初始化
    if (this.$route.query.valueRow) {
      this.backgroundOpacity =
      this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment =
      this.$route.query.statusComment == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.isCopy = this.$route.query.isCopy == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.getLevel();
      this.getEdit();
    } else {
      this.activityTimeChange();
      this.getLevel();
    }
    // this.activityTimeChange();
  },
  methods: {
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.crowdList = [];
    },
    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    async getEdit() {
      const { data } = await editScratchers(this.valueRow);
      this.staute = data.status || 0;
      this.timeState1 = data.startTime;
      this.activityTimeValue = [String(data.startTime), String(data.endTime)];
      if(this.isStartEdit){
        //进行中活动 无法修改活动开启时间
        this.isStartEditTime = String(data.startTime)
      }
      this.ruleForm.activityName = data.activityName;
      this.ruleForm.activityStartTime = String(data.startTime);
      this.ruleForm.activityEndTime = String(data.endTime);
      this.ruleForm.activityObject = data.hasOwnProperty("activityObject")
          ? data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = data.hasOwnProperty("newOldCustomer")
          ? Number(data.newOldCustomer)
          : 0;
        this.crowdList = data.hasOwnProperty("seniorGroupId") && data.seniorGroupId
          ? data.seniorGroupId.split(",")
          : [];
      this.ruleForm.activityRulesText = String(data.ruleDescription); //生成规则
      this.ruleForm.gameTemplateId = data.gameTemplateId;
      this.ruleForm.noWinImageUrl = data.ruleDTO.noWinImageUrl;
      this.ruleForm.winImageUrl = data.ruleDTO.winImageUrl;
      this.ruleForm.thankImageUrl = data.ruleDTO.thankImageUrl
        ? data.ruleDTO.thankImageUrl
        : "";
      this.ruleForm.extraUrl = data.ruleDTO.extraUrl;
      this.ruleForm.oneDayMaxDrawNumber = data.ruleDTO.oneDayMaxDrawNumber;
      this.ruleForm.oneDayMaxRewardNumber = data.ruleDTO.oneDayMaxRewardNumber;
      this.ruleForm.totalMaxDrawNumber = data.ruleDTO.totalMaxDrawNumber;
      this.ruleForm.totalMaxRewardNumber = data.ruleDTO.totalMaxRewardNumber;
      if (this.isCopy) {
        this.awardSettingsLsit = [
          {
            prizeType: null,
            price: null,
            title: "",
            totalAmount: null,
            percentage: null,
          },
        ]
      } else {
        this.awardSettingsLsit = data.integralParadisePrizeDTOS;
        this.awardSettingsLsit.forEach(item=>item.minNum=item.totalAmount)
      }
      this.ruleForm.partner = data.allowLevel.split(",");
      this.ruleForm.membershipTime = data.membershipTime
      this.activityTimeChange();
    },
    handleChoice(val) {
      console.log(val);
      if (val) {
        this.ruleForm.gameTemplateId = val.id;
        this.ruleForm.winImageUrl = val.secondImageUrl;
        this.ruleForm.noWinImageUrl = val.imageUrl;
        this.ruleForm.thankImageUrl = val.thankImageUrl;
      }
      this.giftPopup = false;
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      if(this.isStartEdit){
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0]= this.isStartEditTime
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let CRMtime = new Date(this.orderCRMtime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        // if (days > 90) {
        //   this.$message.warning("活动时间不得超过90天！");
        //   this.ruleForm.activityEndTime = null;
        //   this.timeOut = 0;
        //   this.timeDay = 0;
        //   return;
        // }

        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.valueRow) {
          this.disableTime = true;
        } else {
          // console.log(this.activityTimeValue);
          // this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
          // this.activityTimeValue[0] = "";
          // this.ruleForm.activityStartTime = null;
          // return;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");

        return;
      }
    },
    deletePacket(index) {
      if(this.isStartEdit) return;
      this.awardSettingsLsit.splice(index, 1);
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log("选择奖品", data);
      if (prizeType == 1) {
        this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
        this.awardSettingsLsit[this.awardIndex].price = data.price;
        this.awardSettingsLsit[this.awardIndex].quota = data.quota;
        if (data.couponType == 4) {
          this.awardSettingsLsit[this.awardIndex].batchKey = data.batchKey;
        }
      }
      if (data.giftType) {
        this.awardSettingsLsit[this.awardIndex].giftType = Number(
          data.giftType
        );
      }

      if (data.couponType == 4) {
        this.awardSettingsLsit[this.awardIndex].price = Number(data.price);
      } else {
        this.awardSettingsLsit[this.awardIndex].price = Number(data.discount);
      }

      if (data.couponType == 4) {
        this.awardSettingsLsit[this.awardIndex].assetsId = null;
      } else {
        this.awardSettingsLsit[this.awardIndex].assetsId = Number(
          data.couponId
        );
      }

      this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      if (prizeType == 4) {
        this.awardSettingsLsit[this.awardIndex].title =
          data.discount + "店铺积分";
      } else {
        if (data.couponType == 4) {
          this.awardSettingsLsit[this.awardIndex].title = "优惠券";
        } else {
          this.awardSettingsLsit[this.awardIndex].title = data.name;
        }
      }
      if (data.singleAmount) {
        this.awardSettingsLsit[this.awardIndex].singleAmount =
          data.singleAmount;
      }
      if (prizeType == 2) {
        this.awardSettingsLsit[this.awardIndex].quantityTotal =
          data.quantityTotal;
      }
      if (prizeType == 10) {
        this.awardSettingsLsit[this.awardIndex].price = data.price;
        this.awardSettingsLsit[this.awardIndex].title = data.itemTitle;
        this.awardSettingsLsit[this.awardIndex].title =
          data.itemTitle.length >= 12
            ? data.itemTitle.substring(0, 12)
            : data.itemTitle;
        this.awardSettingsLsit[this.awardIndex].logo = data.picUrl;
        this.awardSettingsLsit[this.awardIndex].assetsId = data.id;
        this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
      }
      console.log(data, 666);
      // if (prizeType == 1) {
      //   this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
      //   this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
      //   this.awardSettingsLsit[this.awardIndex].quota = data.quota;
      // }
      // if (prizeType == 2) {
      //   this.awardSettingsLsit[this.awardIndex].quantityTotal = data.quantityTotal;
      // }
      // if (data.giftType) {
      //   this.awardSettingsLsit[this.awardIndex].giftType = Number(data.giftType);
      // }
      // this.awardSettingsLsit[this.awardIndex].price = data.discount || data.singleAmount;

      // this.awardSettingsLsit[this.awardIndex].assetsId = Number(data.couponId);
      // this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      // this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      // if (prizeType == 4) {
      //   this.awardSettingsLsit[this.awardIndex].title = data.discount + "店铺积分";
      // } else {
      //   this.awardSettingsLsit[this.awardIndex].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      // }
      // if (data.singleAmount) {
      //   this.awardSettingsLsit[this.awardIndex].singleAmount = data.singleAmount;
      // }
      console.log(this.awardSettingsLsit, 123);
    },
    addPacket() {
      if(this.isStartEdit) return;
      this.awardSettingsLsit.push({
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        percentage: null,
      });
    },
    // 红包雨
    selectPacket(index, item) {
      if(this.isStartEdit) return;
      this.$refs.selectProductAward.openDialog();
      this.JingdouCount.prizeCount = item.totalAmount;
      this.awardIndex = index;
      this.echoDate = item;
      this.$refs.selectProductAward.physicalGift(item)
    },
    // 保留小数点后两位
    oninput2(obj) {
      obj = obj.replace(/[^\d.]/g, ""); //清除除了“数字”和“.”以外的字符
      obj = obj.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      obj = obj
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      obj = obj.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3"); //只能输入3个小数
      if (obj > 100) {
        obj = 100;
      }

      let value = obj * 1;
      let winningRate = 0;
      this.awardSettingsLsit.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        obj = 100 - (winningRate - value);
      } else if (winningRate == 100) {
        if (value >= 100) {
          obj = 100;
        } else {
          obj = 100 - (winningRate - value);
          if (value == 0) {
            obj = 0;
          }
        }
      }
      return obj;
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        row.prizeCount = row.totalAmount;
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal(row);
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    // 抽奖判断
    orderChange() {
      if (
        Number(this.ruleForm.oneDayMaxDrawNumber) >
          Number(this.ruleForm.totalMaxDrawNumber) &&
        this.ruleForm.totalMaxDrawNumber &&
        this.ruleForm.oneDayMaxDrawNumber
      ) {
        this.ruleForm.totalMaxDrawNumber = "";
        this.$message.warning("活动期间每人每天抽奖次数不能大于累计抽奖次数");
      }
      if (
        Number(this.ruleForm.oneDayMaxRewardNumber) >
          Number(this.ruleForm.totalMaxRewardNumber) &&
        this.ruleForm.oneDayMaxRewardNumber &&
        this.ruleForm.totalMaxRewardNumber
      ) {
        this.ruleForm.totalMaxRewardNumber = "";
        this.$message.warning("活动期间每人每天中奖次数不能大于累计中奖次数");
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      this.ruleForm.activityStartTime =
        this.activityTimeValue.length == 0 ? "" : this.activityTimeValue[0];
      this.ruleForm.activityEndTime =
        this.activityTimeValue.length == 0 ? "" : this.activityTimeValue[1];
      let cardParams = {
        allowLevel: this.ruleForm.partner.join(","),
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.crowdList.join(","),
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        gameTemplateId: this.ruleForm.gameTemplateId,
        ruleDTO: {
          oneDayMaxDrawNumber: this.ruleForm.oneDayMaxDrawNumber,
          totalMaxDrawNumber: this.ruleForm.totalMaxDrawNumber,
          oneDayMaxRewardNumber: this.ruleForm.oneDayMaxRewardNumber,
          totalMaxRewardNumber: this.ruleForm.totalMaxRewardNumber,
          extraUrl: this.ruleForm.extraUrl,
          noWinImageUrl: this.ruleForm.noWinImageUrl,
          winImageUrl: this.ruleForm.winImageUrl,
          thankImageUrl: this.ruleForm.thankImageUrl,
        }, //活动名称
        integralParadisePrizeDTOS: [], // 奖品
      };
      let isflay = false;
      cardParams.integralParadisePrizeDTOS = this.awardSettingsLsit.map(
        (item) => {
          let prize = {
            ...item,
            title: item.title,
            assetsId: item.assetsId,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount, //
            totalAmount: item.totalAmount, // 总数额
            price: item.price,
            percentage: item.percentage ? item.percentage * 1 : 0,
          };
          if (prize.prizeType == 3) {
            prize.logo = item.logo;
          }
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
          }
          if (prize.prizeType == 2 || prize.prizeType == 4) {
            prize.singleAmount = item.price;
          } else {
            prize.singleAmount = 1;
          }
          if (!item.singleAmount) isflay = true;
          return prize;
        }
      );

      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      if (this.ruleForm.activityObject == 2 && !this.crowdList.length) {
        return this.$message.error("请完善活动对象信息！");
      }
      
      if (isflay) return this.$message.warning(`请把奖项设置填写完整`);

      if (!this.ruleForm.noWinImageUrl || !this.ruleForm.winImageUrl)
        return this.$message.warning(`请选择活动图片`);
      // if (!this.ruleForm.activityRulesText) {
      //   //活动规则不能为空
      //   this.$message.warning("活动规则不能为空");
      //   return;
      // }

      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        if (this.valueRow && !this.isCopy) {
          if (this.staute == 2) cardParams.startTime = this.timeState1;
          saveScratchers({ ...cardParams, id: this.valueRow }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.go(-1);
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          saveScratchers(cardParams).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.go(-1);
            } else {
              this.$message.error(res.message);
            }
          });
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "",
        text10 = "",
        text11 = "",
        text12 = "",
        text13 = "",
        text14 = "",
        text15 = "",
        text16 = "",
        text17 = "",
        text18 = "",
        text19 = "",
        text20 = "",
        text21 = "";
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text1 =
          "1、活动时间：" +
          this.ruleForm.activityStartTime +
          "至" +
          this.ruleForm.activityEndTime +
          "；";
      }
      text2 = `2、抽奖和中奖规则：活动期间每人每天抽奖不超过${this.ruleForm
        .oneDayMaxDrawNumber || "--"}次，累计抽奖不超过${this.ruleForm
        .totalMaxDrawNumber || "--"}次,活动期间每人每天中奖不超过${this.ruleForm
        .oneDayMaxRewardNumber || "--"}次，累计中奖不超过${this.ruleForm
        .totalMaxRewardNumber || "--"}次；`;
      text4 = "4、奖品数量有限，先到先得";
      text5 =
        "5、若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）；";
      text6 = "注：奖品发放形式： 实物奖：";
      text7 =
        "  中奖客户信息收集：页面弹屏提示中奖客户提供收货地址、号码和奖项；(请及时填写，方便奖品发放)";
      text8 =
        "  实物奖采取寄送方式发放，获奖用户需在开奖后填写姓名、联系电话、详细地址信息。如因用户原因无法联系上，即奖品作废不再补发，或如用户未填写真实有效的信息或填写收货信息不详，均视为放弃奖品；";
      text9 = "虚拟产品奖：";
      text10 =
        "  （1）优惠券、店铺积分、支付宝现金红包：中奖后系统预计24小时内自动发放至账户；";
      text11 =
        "  （2）专属下单实物：中奖后需点击跳转至商品页面进行下单，否则商家不会发货。";
      text14 = "活动参与主体资格：";
      text15 =
        "  （1）每位自然人用户仅能使用一个淘宝账号参与活动，微信号、QQ、淘宝帐号、手机号码等任一信息一致或指向同一用户的，视为同一个用户，则第一个参与本活动的账号参与结果有效，其余账号参与结果均视为无效。";
      text16 =
        "  （2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格。";
      text17 = "注意事项：";
      text18 =
        "  （1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利。";
      text19 =
        "  （2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动。";
      text20 =
        "  （3）本活动所发放的实物奖不得提现、不得转赠他人、不得为他人付款。";
      text21 = "  （4）是否中奖以活动发布者后台统计结果为准。";
      let Arr1 = [
        text1,
        text2,
        text4,
        text5,
        text34,
        text6,
        text7,
        text8,
        text9,
        text10,
        text11,
        // text12,
        // text13,
        text14,
        text15,
        text16,
        text17,
        text18,
        text19,
        text20,
        text21,
      ];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    clickLocalStep() {
      this.$router.go(-1);
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 活动进行中修改奖品数量
    beAdd(row){
      console.log("活动进行中修改奖品数量",row);
      if(this.isStartEdit){
        if(row.minNum && Number(row.totalAmount) < Number(row.minNum)){
          row.totalAmount = row.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.smart {
  display: flex;
  margin-top: 24px;
  width: 100%;
  &_left {
    width: 235px;
    height: 430px;
    background: url("~@/assets/thdImg/active/ggl.png") no-repeat;
    background-size: 235px 430px;
    margin-right: 30px;
    display: flex;
    justify-content: center;
  }
  &_content {
    width: 93%;
    // background: #2670FB;
    height: 100px;
    margin-top: 129px;
    img {
      width: 100%;
      height: inherit;
    }
  }
  &_right {
    width: 235px;
    height: 430px;

    background: url("~@/assets/thdImg/active/ggl.png") no-repeat;
    background-size: 235px 430px;
    display: flex;
    justify-content: center;
    // &_img {
    //   height: 430px;
    //   background: #999;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    // }
  }
}
.smart_right_tip {
  width: 500px;
  color: #999;
  margin-top: 5px;
  font-size: 12px;
  text-align: center;
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #2670fb;
    color: #2670fb;
  }
}
.card-point {
  width: 100%;
  background: #f4f7ff;
  border-radius: 4px;
  margin-top: 20px;
  padding: 12px 0px 12px 20px;
  // display: flex;
  .card-rule {
    // margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("../../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
    line-height: 1;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.add_btn1 {
  cursor: pointer;
  color: #2670fb;
  border: 1px solid #2670fb;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(38, 112, 251, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.memberTips {
  color: red;
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/ .el-table__body-wrapper {
  overflow: visible !important;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}

.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
}

.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rule_box {
  width: 860px;
  // height: 217px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
  }
  &_bottom {
    margin-left: 7px;
  }
}

.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #2670fb;
  }
  color: #999;
}
.delectPosible {
  position: absolute;
  top: -3px;
  right: 6px;
  color: red;
  cursor: pointer;
}
.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}

.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }

  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 24px 28px 1px 24px;
    // margin-bottom: 29px;
    height: calc(100vh - 225px);
    overflow-y: auto;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url("../../../assets/images/integralCenter/yhq.png");
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #2670fb;
      color: #2670fb;
      transition: all 0.2s;
      &:hover {
        background-color: #2670fb;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2670fb;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
::v-deep .keepBtn {
  margin-left: 30px;
  width: 188px;
  background-color: #2670fb;
  color: #fff;
  transition: all 0.2s;
  &:hover {
    opacity: 0.9;
  }
}
</style>

<style lang="scss">
.createPlayStep {
  .el-step.is-horizontal .el-step__line {
    height: 1px;
  }
  .el-step__head.is-success {
    color: #2670fb;
    border-color: #2670fb;
    .el-step__line {
      background-color: #2670fb;
    }
  }
  .el-step__head.is-process {
    color: #2670fb;
    border-color: #2670fb;
  }
  .el-step__title.is-process {
    color: #2670fb;
  }
  .el-step__title.is-success {
    color: #2670fb;
  }
  // .textarea {
  //   .el-textarea__inner {
  //     min-height: 80px !important;
  //   }
  // }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
.margin-left-8 {
  margin-left: 8px;
}
.margin-left-12 {
  margin-left: 12px;
  i {
    cursor: pointer;
    color: #ccc;
  }
}
.tips-style {
  color: #cccccc;
}
</style>
